import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const JOB_HEARTBEAT = gql(`
  mutation JobHeartbeat($id: ID!) {
    jobHeartbeat(id: $id) {
      __typename
      ... on JobHeartbeatSuccess {
        __typename
        id
      }
      ... on JobHeartbeatFailure {
        __typename
        result
      }
      ... on JobNotFound {
        __typename
        id
      }
    }
  }
`);

export function useJobHeartbeat(id: string) {
  return useMutation(JOB_HEARTBEAT, { variables: { id } });
}
